import axios from 'axios';
import objectToQuery from '../../functions/object-to-query';
import config from '../../config'

// Utils
import { pushMessage } from '../../utilities/messenger';

axios.defaults.headers.post['Content-Type'] = undefined;

const requestUtil = {
	get: function (target, data = false, finalFunction = false, opts = {}) {
		return makeRequest('get', target, data, finalFunction, opts);
	},
	post: function (target, data = false, finalFunction = false, opts = {}) {
		return makeRequest('post', target, data, finalFunction, opts);
	},
	put: function (target, data = false, finalFunction = false, opts = {}) {
		return makeRequest('put', target, data, finalFunction, opts);
	},
	delete: function (target, data = false, finalFunction = false, opts = {}) {
		return makeRequest('delete', target, data, finalFunction, opts);
	},
};

export default requestUtil;

const makeRequest = (
	method,
	target,
	data = false,
	finalFunction = false,
	opts = {}
) => {
	try {
		if (data === false) {
			data = {};
		}

		let requestOpts = {
			static: false,
			exceptionOnError: false,
			showMessages: [],
			external: false,
			excludeApiPath: false,
			target: target,
			method: method,
			ignoreGuestToken: false,
			...opts,
		};

		if (requestOpts.showMessages === true) {
			requestOpts.showMessages = requestOpts.exceptionOnError
				? ['success']
				: ['error', 'success', 'warning'];
		}

		let ajaxToken = axios.CancelToken;
		let ajaxController = ajaxToken.source();

		requestOpts.target = generateApiPath(
			requestOpts
		);

		let ajaxOpts = {
			method: requestOpts.method,
			url: requestOpts.target,
			cancelToken: ajaxController.token,
			crossdomain: true,
		};

		if (requestOpts.method === 'get' && data) {
			let dataQuery = objectToQuery(data);
			if (dataQuery.length) {
				ajaxOpts.url += '?' + dataQuery;
			}
		} else {
			ajaxOpts.data = data;
		}

		requestOpts.data = data;
		requestOpts.headers = ajaxOpts.headers;

		axios(ajaxOpts)
			.then((res) => {
				evaluateData(res, finalFunction, requestOpts);
			})
			.catch((error) => {
				evaluateData(
					error.response
						? error.response
						: { status: 500, data: {}, error: error },
					finalFunction,
					requestOpts
				);
			});

		return ajaxController;
	} catch (e) {
		console.error('Request error:', e);
		if (finalFunction) {
			finalFunction(false);
		}
		return false;
	}
};

const evaluateData = (response, finalFunction = false, config) => {
	if ([500, 429].includes(response.status)) {
		if (config.exceptionOnError) {
			throw `Request status ${response.status}`;
		}
		if (finalFunction) {
			finalFunction(false, response.status, response);
		}
	} else {
		let hasMessage = false;

		// Messenger
		if (!config.external) {
			if (response.data.meta && response.data.meta.messages) {
				for (const msgType in response.data.meta.messages) {
					if (
						response.data.meta.messages[msgType].length > 0 &&
						config.showMessages &&
						config.showMessages.includes(msgType)
					) {
						for (const message of response.data.meta.messages[
							msgType
						]) {
							pushMessage(message, { type: msgType });
							hasMessage = true;
						}
					}
				}
			}
		}

		switch (response.status) {
			case 200:
			case 201:
				if (finalFunction) {
					finalFunction(
						config.external ? response.data : response.data.payload,
						response.status,
						response
					);
				}
				break;
			default:
				if (
					!config.external &&
					!hasMessage &&
					config.showMessages &&
					config.showMessages.includes('error')
				) {
					pushMessage('Hata: İşlem başarısız.', { type: 'error' });
				}

				if (finalFunction) {
					finalFunction(false, response.status, response);
				}
				break;
		}
	}
};

const generateApiPath = (requestOpts) => {
	if(requestOpts.static) {
		return `${config.siteURL}/${requestOpts.target}`;
	}

	if(requestOpts.excludeApiPath || requestOpts.external) {
		return `${requestOpts.target}`;
	}

	return `${config.apiURL}${requestOpts.target}`;
};
